// @flow
import type { NewAction } from '~/core/types/beekeeper/actions';
import { createAction } from 'redux-actions';
import {
    ADD_ACTION_ATTRIBUTE,
    ATTEMPT_CREATE_ACTION,
    ATTEMPT_EDIT_ACTION,
    ATTEMPT_REMOVE_ACTION,
    ATTEMPT_TRIGGER_QUICK_ACTION,
    CANCEL_FORM,
    EDIT_ACTION,
    END_ATTEMPT,
    END_ATTEMPT_CREATE_ACTION,
    GET_ACTIONS,
    GET_TEMPLATES,
    LOAD_FORM,
    RECEIVE_ACTIONS,
    RECEIVE_TEMPLATES,
    REMOVE_ACTION_ATTRIBUTE,
    REMOVE_ACTION_FROM_LIST,
    REMOVE_ACTION_FROM_DELETE_LIST,
    RESET_QUICK_ACTION_STATUS,
    SET_ACTION_ATTRIBUTE,
    SET_ACTION_FORM,
    TRIGGER_QUICK_ACTION
} from './constants';

export const addActionAttribute = createAction(ADD_ACTION_ATTRIBUTE);
export const attemptCreateAction = createAction(ATTEMPT_CREATE_ACTION);
export const attemptEditAction = createAction(ATTEMPT_EDIT_ACTION);
export const attemptRemoveAction = createAction(ATTEMPT_REMOVE_ACTION);
export const attemptTriggerQuickAction = createAction(ATTEMPT_TRIGGER_QUICK_ACTION);
export const cancelForm = createAction(CANCEL_FORM);
export const editAction = createAction(EDIT_ACTION);
export const endAttempt = createAction(END_ATTEMPT);
export const endAttemptCreateAction = createAction(END_ATTEMPT_CREATE_ACTION);
export const getActions = createAction(GET_ACTIONS);
export const getTemplates = createAction(GET_TEMPLATES);
export const loadForm = createAction(LOAD_FORM);
export const makeEndAttemptCreateAction = ({ newAction, created }: { newAction: NewAction, created: number }) =>
    createAction(END_ATTEMPT_CREATE_ACTION, ({ nodeId }) => ({ ...newAction, created, id: nodeId }));
export const receiveActions = createAction(RECEIVE_ACTIONS);
export const receiveTemplates = createAction(RECEIVE_TEMPLATES);
export const removeActionAttribute = createAction(REMOVE_ACTION_ATTRIBUTE);
export const removeActionFromList = createAction(REMOVE_ACTION_FROM_LIST);
export const removeActionFromDeleteList = createAction(REMOVE_ACTION_FROM_DELETE_LIST);
export const setActionAttribute = createAction(SET_ACTION_ATTRIBUTE);
export const setActionForm = createAction(SET_ACTION_FORM);
export const triggerQuickAction = createAction(TRIGGER_QUICK_ACTION);
export const resetQuickActionStatus = createAction(RESET_QUICK_ACTION_STATUS);



// WEBPACK FOOTER //
// ./src/core/state/actions/actions.js